const createQueryObject = (queryString) => {
	const firstArray = queryString.split('?');
	firstArray.shift();
	const newArray = firstArray.map((entry) => entry.split('='));
	let newObject = {};
	newArray.forEach((entry) => {
		newObject = { [entry[0]]: entry[1], ...newObject };
	});
	return newObject;
};

const throttle = (callback, limit) => {
	// https://stackoverflow.com/questions/27078285/simple-throttle-in-js
	let waiting = false; // Initially, we're not waiting
	return (...args) => {
		// We return a throttled function
		if (!waiting) {
			// If we're not waiting
			callback.apply(this, args); // Execute users function
			waiting = true; // Prevent future invocations
			setTimeout(() => {
				// After a period of time
				waiting = false; // And allow future invocations
			}, limit);
		}
	};
};

const sample = (arr) => {
	const len = arr == null ? 0 : arr.length;
	return len ? arr[Math.floor(Math.random() * len)] : undefined;
};

// adapted from https://stackoverflow.com/questions/9229645/remove-duplicate-values-from-js-array
const uniq = (a) => {
	// function to remove duplicates from array without using excessive memory
	const prims = { boolean: {}, number: {}, string: {} };
	const objs = [];

	return a.filter((item) => {
		const type = typeof item;
		if (type in prims) {
			if (prims[type].hasOwnProperty(item)) {
				return false;
			}
			prims[type][item] = true;
			return true;
		} else {
			if (objs.indexOf(item) >= 0) {
				return false;
			}
			objs.push(item);
			return true;
		}
	});
};

const groupBy = (xs, key) =>
	// https://stackoverflow.com/questions/14446511/most-efficient-method-to-groupby-on-an-array-of-objects
	xs.reduce((rv, x) => {
		(rv[x[key]] = rv[x[key]] || []).push(x);
		return rv;
	}, {});

const checkIfObjectEmpty = (obj) =>
	!obj || // 👈 null and undefined check
	(obj.constructor === Object && Object.keys(obj).length === 0);

const sortArrayOfObjects = (property) => (a, b) => a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;

const getUniqueStringsFromArray = (array) => {
	const uniqueStrings = [];
	array?.forEach((item, i) => {
		if (item && typeof item === 'string' && !uniqueStrings.includes(item)) uniqueStrings.push(item);
	});
	return uniqueStrings;
};

const createRandomColor = () => `#${Math.floor(Math.random() * 16777215).toString(16)}`;

const getUniqueElementsFromArray = (array) => [...new Set(array)];

export {
	createQueryObject,
	throttle,
	sample,
	uniq,
	groupBy,
	checkIfObjectEmpty,
	sortArrayOfObjects,
	getUniqueStringsFromArray,
	createRandomColor,
	getUniqueElementsFromArray,
};
